import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toHandlers as _toHandlers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1f8fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "build-group-tooltip" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Enabled as Helper ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Allow to 'Enable/Disable' as Helper ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Allow to 'Enable/Disable' as Helper ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Remove All Agent Roles ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Update Version ")

import IncrediCheckBox from '@/components/inputs/incrediCheckBox.vue';
import { computed, ref, VNodeRef } from 'vue';
import { License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import AgentsAddBuildGroup from '@/views/agents/components/action-menu/agents-build-group.vue';
import { useDialogPresets } from '@/services/dialogPresets.composable';
import AgentActionSetDescription from '@/components/agents-table/AgentActionSetDescription.vue';
import elementsIds from '@/const/elementIds.json';
import { useAgentActionMenuUtils } from '@/components/agents-table/AgentTable/components/AgentActionMenu/OS/AgentActionMenu.helpers';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { IncrediTooltip, useIncrediDialog } from 'incredi-ui';
import manageBuildGroupsDialog from '@/views/agents/components/buildGroups/manageBuildGroupsDialog.vue';
import ManageClustersDialog from '@/views/agents/components/buildcache-clusters/manageClustersDialog.vue';
import InitiatorActionLicenseConf from '@/components/agents-table/AgentActionLicenseConf/InitiatorActionLicenseConf.vue';
import AgentsBuildCacheClusters from '@/views/agents/components/action-menu/agents-buildCache-clusters.vue';
import { useI18n } from 'vue-i18n';
import AssignmentPriority from '../../../../AgentActionAssignmentPriority.vue';
import BuildPriority from '../../../../AgentActionBuildPriority.vue';
import LogLevel from '../../../../AgentActionLogLevel.vue';
import HelperLicenseConfiguration from '../../../../AgentActionLicenseConf/HelperActionLicenseConf.vue';
import AgentEnableBuildCache from '../../../../AgentEnableBuildCache.vue';
import AgentLimitedBulkActionMenu from '../../../../AgentLimitedBulkActionMenu.vue';
import AgentCloudBulkActionMenu from '../../../../AgentCloudBulkActionMenu.vue';
import AgentActionResizeCache from '../../../../AgentActionResizeCache.vue';
import ValueSelector from '../../../../../ValueSelector.vue';
import { useNotifyPresets } from '../../../../services/notifyPresets';
import { useMenuPermissions } from '../../../../services/agentsMenuOptionsPermissions';
import AgentActionBuildCacheConfiguration from '../../../../AgentActionBuildCacheConfiguration.vue';
import AgentActionFolderLocation from '../../../../AgentActionFolderLocation.vue';
import { useAgentActionsMenu } from '../../../../AgentActionsMenu.helpers';
import { SelectedAgent } from '../../../../AgentActionMenu.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentActionMenu.windows',
  props: {
    beforeHide: null,
    agent: null,
    contextMenu: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  beforeHide?: () => void;
  agent: SelectedAgent;
  contextMenu?: boolean;
}

// import { mapGetters, useStore } from 'vuex';
const IcmMenuRef = ref<VNodeRef>();
const agentsActions = useAgentActionsMenu(OsType.Windows, IcmMenuRef);
const { dialogPresets } = useDialogPresets();
const { notifyPresets } = useNotifyPresets();
const dialog = useIncrediDialog();
const { getPermissions } = useMenuPermissions();
const agentsActionsMenu = useAgentActionMenuUtils();



const showTooltip = ref(false);
const { t } = useI18n();
const isSetInitiatorRoleDisabled = computed(() => !getPermissions.setInitiatorBuildGroup([props.agent]) || !getPermissions.setInitiatorRoleForSCL([props.agent]));

const getInitiatorRoleDisabledTooltip = computed(() => {
  if (!getPermissions.setInitiatorBuildGroup([props.agent]) && getPermissions.setInitiatorRoleForSCL([props.agent])) {
    return t('agentsTable.universalHelperTooltipForInitiator');
  }
  if (!getPermissions.setInitiatorRoleForSCL([props.agent])) {
    return t('agentsTable.sclAgentTooltipForInitiator');
  }
  return '';
});

const showSetInitiatorRoleTooltipModel = computed({
  get() {
    return showTooltip.value;
  },
  set(value) {
    if (isSetInitiatorRoleDisabled.value) {
      showTooltip.value = value;
    }
  },
});
const leaveOpen = ref(false);

const openSetConfigurationDialog = () => {
  dialogPresets.value?.setRegistryKey([props.agent]);
};

const openBuildGroupsDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide(); // close agent actions menus
  dialog?.open('manageBuildGroupsDialog', manageBuildGroupsDialog, {});
};

const openBuildCacheClustersDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide();
  dialog?.open('manageBuildCacheClustersDialog', ManageClustersDialog, {});
};

const isAgentIncompatibleVersion = computed(() => props.agent?.metadata?.isIncompatibleVersion);
const isDuplicatedMenu = computed(() => props.agent?.metadata?.isDuplicateLicense);
const isCloudMenu = computed(() => props.agent?.metadata?.isCloud);
const isDefaultList = computed(() => !isDuplicatedMenu.value && !isCloudMenu.value && !isAgentIncompatibleVersion.value);
const menuOptions = computed(() => ({
  attrs: {
    rootClass: 'incredi-q-menu incredi-q-menu-agents',
    activeClass: 'incredi-q-item-active',
    'context-menu': props.contextMenu,
    ...(agentsActionsMenu.menuOpeningDirection.value as { self: string; anchor: string }),
  },
  listeners: {
    'before-hide': props.beforeHide,
    'before-show': agentsActionsMenu.beforeShow,
  },
}));
const isMenuItemDisabled = computed(() => isAgentIncompatibleVersion.value || props.agent?.metadata?.isOffline);
const onAgentsBuildCacheClustersChange = ({ clusterId }: { clusterId: number }) => {
  if (clusterId) {
    agentsActions.setBuildCacheClusterUpdateNodes([props.agent], clusterId);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_IcmMenuSubmenu = _resolveComponent("IcmMenuSubmenu")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_IcmMenuItem = _resolveComponent("IcmMenuItem")!
  const _component_IcmMenu = _resolveComponent("IcmMenu")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(_component_IcmMenu, _mergeProps({
    ref_key: "IcmMenuRef",
    ref: IcmMenuRef,
    "hover-mode": "",
    persistent: leaveOpen.value
  }, _unref(menuOptions).attrs, _toHandlers(_unref(menuOptions).listeners)), {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.agent.name), 1)
    ]),
    default: _withCtx(({ bind }) => [
      _createVNode(_unref(IncrediTooltip), {
        modelValue: _unref(showSetInitiatorRoleTooltipModel),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showSetInitiatorRoleTooltipModel) ? (showSetInitiatorRoleTooltipModel).value = $event : null)),
        direction: "middle-right",
        "offset-x": 10,
        hover: _unref(isSetInitiatorRoleDisabled),
        delay: 200,
        class: _normalizeClass(!_unref(getPermissions).setLicenseConfiguration([__props.agent]) || _unref(isCloudMenu) ? 'resetHeight' : '')
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getInitiatorRoleDisabledTooltip)), 1)
        ]),
        default: _withCtx(() => [
          (_unref(getPermissions).setLicenseConfiguration([__props.agent]) && !_unref(isCloudMenu))
            ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
                key: 0,
                ref: "initiator-license-configuration",
                "data-testid": "agentsTable.actionsMenu.setInitiatorRole",
                label: _ctx.$t('agentsTable.actionsMenu.setInitiatorRole'),
                disabled: _unref(isSetInitiatorRoleDisabled)
              }, bind, { portal: "" }), {
                default: _withCtx(() => [
                  ((_ctx.$refs['initiator-license-configuration'] as any))
                    ? (_openBlock(), _createBlock(InitiatorActionLicenseConf, {
                        key: 0,
                        "update-position": (_ctx.$refs['initiator-license-configuration'] as any).updatePosition,
                        "agents-list": [__props.agent],
                        onSubmit: _unref(agentsActions).setAgentsLicense
                      }, null, 8, ["update-position", "agents-list", "onSubmit"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040, ["label", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["modelValue", "hover", "class"]),
      (_unref(getPermissions).buildCache([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 0,
            ref: "enable-build-cache-configuration",
            portal: "",
            label: _ctx.$t('agentsTable.agentBuildCacheConfiguration.title')
          }, bind, {
            "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.menuItem,
            persistent: leaveOpen.value
          }), {
            default: _withCtx(() => [
              ((_ctx.$refs['enable-build-cache-configuration'] as any))
                ? (_openBlock(), _createBlock(AgentEnableBuildCache, {
                    key: 0,
                    style: {"width":"336px","max-height":"initial !important","max-width":"initial !important"},
                    agents: [__props.agent],
                    "update-position": (_ctx.$refs['enable-build-cache-configuration'] as any).updatePosition,
                    onSubmit: _unref(agentsActions).setLicenseBuildAvoidance,
                    onPreventContextClose: _cache[1] || (_cache[1] = value => (leaveOpen.value = value))
                  }, null, 8, ["agents", "update-position", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label", "data-testid", "persistent"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setBuildPriority([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 1,
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.buildPriority')
          }, bind, {
            "auto-close": "",
            "data-testid": "build-priority-item"
          }), {
            default: _withCtx(() => [
              _createVNode(ValueSelector, { title: "Build Priority" }, {
                default: _withCtx(() => [
                  _createVNode(BuildPriority, {
                    selected: props.agent?.buildPriority,
                    "agent-name": __props.agent.name,
                    onChange: _cache[2] || (_cache[2] = (value) => _unref(agentsActions).setBuildPriority([__props.agent], value))
                  }, null, 8, ["selected", "agent-name"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(isDefaultList))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 2,
            class: "menu-separator"
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setLicenseConfiguration([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 3,
            ref: "license-configuration",
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.setHelperRole')
          }, bind, { "data-testid": "license-configuration-action" }), {
            default: _withCtx(() => [
              ((_ctx.$refs['license-configuration'] as any))
                ? (_openBlock(), _createBlock(HelperLicenseConfiguration, {
                    key: 0,
                    "agents-list": [__props.agent],
                    "update-position": (_ctx.$refs['license-configuration'] as any).updatePosition,
                    onSubmit: _unref(agentsActions).setAgentsLicense
                  }, null, 8, ["agents-list", "update-position", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setHelperEnabled([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 4,
            "auto-close": false,
            "data-testid": "enable-disable-as-helper-action",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(agentsActions).setHelperEnabled([__props.agent], !__props.agent.enabled)))
          }, {
            prepend: _withCtx(() => [
              _createVNode(IncrediCheckBox, {
                disable: _unref(isMenuItemDisabled),
                value: __props.agent.enabled,
                onInput: _cache[3] || (_cache[3] = (value) => _unref(agentsActions).setHelperEnabled([__props.agent],value))
              }, null, 8, ["disable", "value"])
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setHelperConfigurations([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 5,
            "data-testid": "helper-configurations-action",
            label: _ctx.$t('agentsTable.actionsMenu.helperConfigurations')
          }, bind), {
            default: _withCtx(() => [
              (_unref(getPermissions).setAssignmentPriority([__props.agent]))
                ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
                    key: 0,
                    portal: "",
                    label: _ctx.$t('agentsTable.actionsMenu.assignmentPriority')
                  }, bind, {
                    "auto-close": "",
                    "data-testid": "assignment-priority-action"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(ValueSelector, { title: "Assignment Priority" }, {
                        default: _withCtx(() => [
                          _createVNode(AssignmentPriority, {
                            selected: props.agent?.assignPriority,
                            "agent-name": __props.agent.name,
                            onChange: _cache[5] || (_cache[5] = value => _unref(agentsActions).setAssignmentPriority([__props.agent], value))
                          }, null, 8, ["selected", "agent-name"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040, ["label"]))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setResizeCache([__props.agent]))
                ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
                    key: 1,
                    portal: "",
                    label: 'Resize Helper Cache'
                  }, bind, { "data-testid": "resize-helper-cache-action" }), {
                    default: _withCtx(() => [
                      _createVNode(AgentActionResizeCache, {
                        "agents-list": [__props.agent],
                        onSubmit: _cache[6] || (_cache[6] = (value) => value ? _unref(agentsActions).setReizeCache([__props.agent],value): null)
                      }, null, 8, ["agents-list"])
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setClearCache([__props.agent]))
                ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
                    key: 2,
                    flat: "",
                    "data-testid": "clear-helper-cache-action",
                    onClick: _cache[7] || (_cache[7] = () => _unref(agentsActions).setClearCache([__props.agent]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.actionsMenu.cleanCache')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setAllowHelperEnabled([__props.agent]))
                ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
                    key: 3,
                    "auto-close": false,
                    "data-testid": "agent-helper-permissions-action",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(agentsActions).setAllowHelperEnabled([__props.agent], !__props.agent.allowEnableDisable)))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(IncrediCheckBox, {
                        value: __props.agent.allowEnableDisable,
                        disable: _unref(isAgentIncompatibleVersion),
                        onInput: _cache[8] || (_cache[8] = (value) => _unref(agentsActions).setAllowHelperEnabled([__props.agent],value))
                      }, null, 8, ["value", "disable"])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label"]))
        : (_unref(getPermissions).setAllowHelperEnabled([__props.agent]))
          ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
              key: 6,
              "auto-close": false,
              "data-testid": "agent-helper-permissions-action",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(agentsActions).setAllowHelperEnabled([__props.agent], !__props.agent.allowEnableDisable)))
            }, {
              prepend: _withCtx(() => [
                _createVNode(IncrediCheckBox, {
                  value: __props.agent.allowEnableDisable,
                  disable: _unref(isAgentIncompatibleVersion),
                  onInput: _cache[10] || (_cache[10] = (value) => _unref(agentsActions).setAllowHelperEnabled([__props.agent],value))
                }, null, 8, ["value", "disable"])
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      (_unref(isDefaultList))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 7,
            class: "menu-separator"
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).buildCacheConfiguration([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 8,
            ref: "build-cache-configuration",
            label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.title')
          }, bind, {
            "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheConfiguration.submenu
          }), {
            default: _withCtx(() => [
              _createVNode(_component_IcmMenuSubmenu, _mergeProps(bind, {
                ref: "build-cache-configuration",
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.cacheSize'),
                disabled: _unref(isAgentIncompatibleVersion),
                "data-testid": "cache-size-submenu"
              }), {
                default: _withCtx(() => [
                  ((_ctx.$refs['build-cache-configuration'] as any))
                    ? (_openBlock(), _createBlock(AgentActionBuildCacheConfiguration, {
                        key: 0,
                        "build-cache-settings": __props.agent.buildCacheSettings || undefined,
                        "update-position": (_ctx.$refs['build-cache-configuration'] as any).updatePosition,
                        onSubmit: _cache[12] || (_cache[12] = data => _unref(agentsActions).setBuildCacheSizeGB({ agents: [__props.agent], cacheSizeGB: Number(data.CacheSizeGB) }))
                      }, null, 8, ["build-cache-settings", "update-position"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040, ["label", "disabled"]),
              _createVNode(_component_IcmMenuSubmenu, _mergeProps(bind, {
                ref: "build-cache-folder-location",
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.folderLocation'),
                disabled: _unref(isAgentIncompatibleVersion),
                "data-testid": "build-cache-folder-location-action"
              }), {
                default: _withCtx(() => [
                  ((_ctx.$refs['build-cache-folder-location'] as any))
                    ? (_openBlock(), _createBlock(AgentActionFolderLocation, {
                        key: 0,
                        "build-cache-settings": __props.agent.buildCacheSettings,
                        "update-position": (_ctx.$refs['build-cache-folder-location'] as any).updatePosition,
                        onSubmitAction: _cache[13] || (_cache[13] = data => _unref(agentsActions).setBuildCacheFolderLocation({ agents: [__props.agent], cacheFolder: data.CacheFolder, databaseFolder: data.DatabaseFolder }))
                      }, null, 8, ["build-cache-settings", "update-position"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040, ["label", "disabled"]),
              _createVNode(_component_IcmMenuSubmenu, _mergeProps(bind, {
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.cacheCluster'),
                "data-testid": "build-cache-cache-cluster-action"
              }), {
                default: _withCtx(() => [
                  _createVNode(AgentsBuildCacheClusters, {
                    "data-test-id": "add-to-buildcache-cluster-action-dialog",
                    agents: [__props.agent],
                    onChange: onAgentsBuildCacheClustersChange,
                    onOpenDialog: openBuildCacheClustersDialog
                  }, null, 8, ["agents"])
                ]),
                _: 2
              }, 1040, ["label"])
            ]),
            _: 2
          }, 1040, ["label", "data-testid"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setAgentDescription([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 9,
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.agentDescription.title')
          }, bind, { "data-testid": "agent-description-item" }), {
            default: _withCtx(() => [
              _createVNode(AgentActionSetDescription, {
                "data-testid": "agent-description-dialog",
                "agents-list": [__props.agent],
                onSubmit: _cache[14] || (_cache[14] = (value) => _unref(agentsActions).setAgentDescription([__props.agent], value))
              }, null, 8, ["agents-list"])
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setBuildGroup([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 10,
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.buildGroup')
          }, bind, { "data-testid": "add-to-build-group-action" }), {
            default: _withCtx(() => [
              _createVNode(AgentsAddBuildGroup, {
                "data-testid": "add-to-build-group-action-dialog",
                agents: [__props.agent],
                onOpenDialog: _cache[15] || (_cache[15] = () => openBuildGroupsDialog()),
                onChange: _cache[16] || (_cache[16] = 
            value => {
              value.status ? _unref(agentsActions).setBuildGroup([__props.agent], value.buildGroup) : _unref(notifyPresets).agentSingeActionFail();
            }
          )
              }, null, 8, ["agents"])
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setLogLevel([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 11,
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.logLevel')
          }, bind, {
            "auto-close": "",
            "data-testid": "log-level-item"
          }), {
            default: _withCtx(() => [
              _createVNode(ValueSelector, { title: "Log Level" }, {
                default: _withCtx(() => [
                  _createVNode(LogLevel, {
                    selected: props.agent?.logLevel,
                    "agent-name": __props.agent.name,
                    onChange: _cache[17] || (_cache[17] = (value) => _unref(agentsActions).setLogLevel([__props.agent], value))
                  }, null, 8, ["selected", "agent-name"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setRegistryKey([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 12,
            "data-testid": "advanced-configuration-action",
            onClick: openSetConfigurationDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.setRegistryKey.title')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setRemoveAgentLicense([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 13,
            disabled: __props.agent?.metadata?.isLocal || false,
            "data-test-id": "unsubscribe-agent-action",
            onClick: _cache[18] || (_cache[18] = () => _unref(agentsActions).setRemoveAgentLicense([__props.agent], _unref(License_RegisterAgentAction).UnsubscribeAgent))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(isDuplicatedMenu))
        ? (_openBlock(), _createBlock(AgentLimitedBulkActionMenu, _mergeProps({
            key: 14,
            ref: "limited-menu",
            "hover-mode": "",
            agents: [__props.agent]
          }, _unref(menuOptions).attrs, _toHandlers(_unref(menuOptions).listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true),
      (_unref(isCloudMenu) && !_unref(isDuplicatedMenu))
        ? (_openBlock(), _createBlock(AgentCloudBulkActionMenu, _mergeProps({
            key: 15,
            ref: "cloud-menu",
            "hover-mode": "",
            agents: [__props.agent]
          }, _unref(menuOptions).attrs, _toHandlers(_unref(menuOptions).listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setUpdateVersion([__props.agent]))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 16,
            disabled: !__props.agent?.metadata?.isValidForVersionUpdate,
            "data-testid": "update-version-action",
            onClick: _cache[19] || (_cache[19] = () => _unref(agentsActions).setUpdateVersion([__props.agent]))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["persistent"])), [
    [_directive_incredi_focus_trap, 'agent-action-menu']
  ])
}
}

})